import { atom } from 'jotai';
import { StoryData } from 'storyblok-js-client';
import { appAtom } from './App.atom';

const storiesByTagsAtom = atom<{ [key: string]: StoryData }>((get) => get(appAtom)?.storiesByTags);

export { storiesByTagsAtom };
